import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { BrandButton } from './ui-kit/BrandButton';
import { Reveal } from './ui-kit/Reveal';

const CTA = () => {
  const { t } = useLanguage();
  return (
    <section className="py-16 md:py-24 bg-bg" data-testid="cta-section">
      <div className="container-page">
        <div className="rounded-hero bg-dark text-white px-7 md:px-14 py-14 md:py-20 relative overflow-hidden">
          <div
            aria-hidden
            className="absolute inset-0 opacity-[0.05]"
            style={{
              backgroundImage:
                'linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)',
              backgroundSize: '80px 80px',
            }}
          />
          <div className="relative grid md:grid-cols-12 gap-8 items-center">
            <div className="md:col-span-8">
              <Reveal>
                <h2 className="text-h1 text-white">{t.cta.title}</h2>
              </Reveal>
              <Reveal delay={80}>
                <p className="mt-5 text-body-lg text-white/85 max-w-xl">{t.cta.subtitle}</p>
              </Reveal>
            </div>
            <Reveal delay={140} className="md:col-span-4 flex md:justify-end">
              <BrandButton
                to="/yhteys#contact-form"
                variant="primary"
                size="lg"
                iconRight={ArrowRight}
                data-testid="cta-contact-btn"
              >
                {t.cta.button}
              </BrandButton>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
